export enum TableDnDType {
  Default = 'DEFAULT',
  Folder = 'FOLDER'
}

export enum DndDroppableContainerIds {
  SharedLibrary = 'SHARED_LIBRARY',
  DataTable = 'DATA_TABLE'
}
